import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, FileText, Calendar, DollarSign } from "lucide-react";

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-400">Caricamento…</div>;
  return (
    <div className="space-y-6 fade-slide" data-testid="admin-overview">
      <h1 className="text-3xl font-bold text-[#0A0A0A]">Panoramica globale</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card icon={Users} label="Utenti totali" value={data.total_users} color="#404040" />
        <Card icon={FileText} label="Lead totali" value={data.total_leads} color="#B40101" />
        <Card icon={Calendar} label="Lead questo mese" value={data.leads_month} color="#F59E0B" />
        <Card icon={DollarSign} label="MRR stimato" value={`€${data.mrr_estimated.toFixed(2)}`} color="#10B981" sub={`${data.active_subscriptions} active`} />
      </div>
    </div>
  );
}

function Card({ icon: Icon, label, value, color, sub }) {
  return (
    <div className="vg-card p-6">
      <div className="w-12 h-12 rounded-[12px] flex items-center justify-center mb-3" style={{ background: `${color}15` }}>
        <Icon size={22} color={color} />
      </div>
      <p className="text-xs uppercase font-semibold text-gray-400">{label}</p>
      <p className="text-3xl font-bold text-[#0A0A0A] mt-1" style={{ fontFamily: "Outfit" }}>{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
}
